import React, { Fragment } from "react";
import JSIcon from "./Icons/JSIcon";
import GitIcon from "./Icons/GitIcon";
import NodeIcon from "./Icons/NodeIcon";
import ReactIcon from "./Icons/ReactIcon";

const About = () => {
  return (
    <Fragment>
      <div className="introPage workandabout">
        <div className="aboutSection" id="About">
          <h5 className="aboutHead">About me</h5>
          <div className="aboutContent">
            <p>
              Hello! I'm Gaurav, a frontend web developer who enjoys building
              web applications.
            </p>

            <p>
              I love working with Javascript and web technologies. I majorly
              work with React JS, Node JS and related technologies.
            </p>

            <p>
              Besides this, I strictly prefer writing well-documented readable
              code.
            </p>

            <p>Technologies I work with:</p>
            <div className="techStack">
              <div className="techStackIcons-js">
                <JSIcon width={28} height={28} fill={"white"} />
              </div>
              <div className="techStackIcons-git">
                <GitIcon width={28} height={28} fill={"white"} />
              </div>
              <div className="techStackIcons-node">
                <NodeIcon width={28} height={28} fill={"white"} />
              </div>
              <div className="techStackIcons-react">
                <ReactIcon width={28} height={28} fill={"white"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default About;
